module.exports = __webpack_public_path__ + "img/goldregen-2020-111.635acac6.jpg";